import {Component, Input, EventEmitter, Output} from '@angular/core';
import {GameSetUpService} from '../../providers/gameSetUp.service';
import { FinishListService } from '../../providers/finishList.service';


@Component({
    selector: 'game-pad-component',
    templateUrl: './game-pad.component.html',
    styleUrls: ['./game-pad.component.scss']
})
export class GamePadComponent {

    @Input() points: number;
    @Input() disabled: boolean;
    @Input() gameData: any;
    @Input() value: number;
    @Output() valueChange = new EventEmitter();
    @Output() editPreviousScore = new EventEmitter();

    public scores: Score[] = [];
    public perDart: boolean = false;
    public scoreValue: string = '';
    public scoreType: ScoreType = ScoreType.normal;
    public showSum: boolean = false;


    public currentThrows: any = [];

    constructor(public gameSetUpService: GameSetUpService, public finishListService: FinishListService) {
    }

    ngOnInit() {
        console.log('GamePadComponent init');
    }

    ngOnChanges() {
        if (this.value !== null) {
            this.scoreValue = '' + this.value;
        } else {
            // this.scoreType = 4;
            this.scoreValue = '';
        }
    }

    isBiggerThan180() {
        let currentScore = this.getCurrentScore() !== '' ? parseInt(this.getCurrentScore(), 10) : 0;
        return this.calcThrowSum() + currentScore > 180;
    }

    onBull() {
        if (this.scoreType === 3) {
            this.scoreValue = '';
        }
    }
    onBouncer() {
        if (this.scoreType === 4) {
            this.scoreValue = '';
        }
    }

    clearCurrentScore() {
        this.scoreType = 0;
        this.scoreValue = '';
    }

    getCurrentScore() {
        switch (this.scoreType) {
            case 0:
                return this.scoreValue;
            case 1:
                return this.getScoreTypeString(this.scoreType) + this.scoreValue;
            case 2:
                return this.getScoreTypeString(this.scoreType) + this.scoreValue;
            case 3:
                return this.getScoreTypeString(this.scoreType);
            case 4:
                return this.getScoreTypeString(this.scoreType);
        }
    }

    scoreToString(score: Score) {
        switch (score.getType()) {
            case 0:
                return score.getValue();
            case 1:
                return this.getScoreTypeString(score.getType()) + score.getValue();
            case 2:
                return this.getScoreTypeString(score.getType()) + score.getValue();
            case 3:
                return this.getScoreTypeString(score.getType());
            case 4:
                return this.getScoreTypeString(score.getType());
        }
    }

    scoreToNumber(score: any) {
        switch (score.type) {
            case 0:
                return score.value;
            case 1:
                return score.value * 2;
            case 2:
                return score.value * 3;
            case 3:
                return 50;
            case 4:
                return null;
        }
    }

    calcThrowSum() {
        let sum: number = 0;
        for (let i = 0; i < this.currentThrows.length; i++) {
            let throwSum = this.scoreToNumber(this.currentThrows[i]);
            if (throwSum != null) {
                sum += throwSum;
            }
        }
        return sum;
    }


    getThrowString() {
        let throwString = [];
        for (let i = 0; i < this.currentThrows.length; i++) {
            throwString.push(this.scoreToString(this.currentThrows[i]) + '+');
        }
        return throwString;
    }

    addNumber(value: number) {
        if (this.scoreValue.length < 4) {
            this.scoreValue += '' + value;
        }
    }

    onPerDart() {
        this.scoreValue = '';
        this.scoreType = ScoreType.normal;
        this.currentThrows = [];
        console.log('ON PER DART', this.perDart);
    }

    removeNumber() {
        this.scoreValue = this.scoreValue.substring(0, this.scoreValue.length - 1);
    }

    disableNumbers() {
        if (this.scoreType === 3 || this.scoreType === 4 || this.showSum || this.scoreValue.length >= 3 || this.isBiggerThan180()) {
            return true;
        } else {
            return false;
        }
    }

    disableDone() {
        if (this.isBiggerThan180()) {
            return true;
        } else {
            return false;
        }
    }

    disableToggles() {
        if (this.showSum) {
            return true;
        } else  {
            return false;
        }
    }

    getScoreTypeString(scoreTypeValue) {
        switch (scoreTypeValue) {
            case 0:
                return '';
            case 1:
                return 'D';
            case 2:
                return 'T';
            case 3:
                return 'Bull';
            case 4:
                return 'X';
        }
    }


    // **** emit throw, but only the calculated value
    addThrow() {
        // this.gameData.addThrow(this.currentThrows);
        console.log('add throw');

        if (this.calcThrowSum() > 0) {
            this.valueChange.emit(this.calcThrowSum());
        } else {
            this.valueChange.emit(null);
        }
    }

    addScore() {

        let value = parseInt(this.scoreValue);
        if (isNaN(value)) {
            value = null;
        }

        this.currentThrows.push(new Score(value, this.scoreType));
        this.clearCurrentScore();
    }


    onDel() {
        if (this.scoreValue !== '') {
            this.removeNumber();
        } else if (this.scoreType !== ScoreType.normal) {
            this.scoreType = ScoreType.normal;
        } else {
            this.editLastScore();
        }
    }

    editLastScore() {
        if (this.currentThrows.length > 0) {
            this.scoreType = this.currentThrows[this.currentThrows.length - 1].getType();
            let value = this.currentThrows[this.currentThrows.length - 1].getValue();
            if (value == null) {
                this.scoreValue = '';
            } else {
                this.scoreValue = '' + this.currentThrows[this.currentThrows.length - 1].getValue();
            }

            this.currentThrows.splice(-1, 1);
        }

    }

    isDone() {
        if (this.perDart) {
            if (this.currentThrows.length >= this.gameSetUpService.throws - 1) {
                return true;
            }
        } else {
            if (this.currentThrows.length >= 0) {
                return true;
            }
        }


    }

    onDone() {
        this.addScore();
        this.nextTeam();
        // this.showSum = true;
    }

    reset() {
        this.clearCurrentScore();
        this.showSum = false;
        this.currentThrows = [];
    }

    nextTeam() {
        this.addThrow();
        this.reset();
    }


    getWayToFinish() {
        let points = this.points;
        if (this.perDart) {
            points = points - this.calcThrowSum();
            console.log('THROW SUM: ', this.calcThrowSum());
        }

        if (points <= 170 && this.gameSetUpService.gameMode === 'X01' && this.points !== null) {
            return this.finishListService.doubleOut[points];
        } else {
            return null;
        }
    }

}








export enum ScoreType {
    normal, double, triple, bull, bouncer
}

export class Score {
    public type: ScoreType = ScoreType.normal;
    public value: number = 0;

    constructor(value: number, type?: ScoreType) {
        this.value = value;

        if (type !== undefined) {
            this.type = type;
        }
    }

    public getType() {
        return this.type;
    }

    public getValue() {
        return this.value;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/game-pad/game-pad.component.ts